export default __webpack_public_path__ + "static/media/ebike.2bf0f23e.jpg";